import React from 'react';
import PropTypes from 'prop-types';
import {Dialogue, Modal, Button, ConfirmLeave, Icon} from '@albert-io/atomic';

/**
 * @todo: Consolidate this modal with the one in SubmitAssignmentButton.react
 */

const ConfirmLeaveUnfinishedAssignment = ({route, onDismiss = () => {}}) => (
  <ConfirmLeave route={route}>
    {({dismiss, confirmLeave}) => (
      <Modal ariaLabel='Confirm assignment submission modal' handleClose={dismiss}>
        {({modalContentStyle}) => {
          return (
            <Dialogue
              inModal
              hideCloseBtn
              className={modalContentStyle}
              handleClose={dismiss}
              alignTitle='center'
              /**
               * @todo: Refactor `title` prop once https://github.com/albert-io/albert-marketplace/pull/9289 is available
               */
              title={<Icon icon={['far', 'exclamation-triangle']} />}
            >
              <Dialogue.Body align='center'>
                You have not submitted answers to all of the questions.
              </Dialogue.Body>
              <Dialogue.BtnGroup direction='column' fillColumn>
                <Button
                  onClick={() => {
                    dismiss();
                    onDismiss();
                  }}
                >
                  Continue assignment
                </Button>
                <Button color='secondary' onClick={confirmLeave}>
                  Leave
                </Button>
              </Dialogue.BtnGroup>
            </Dialogue>
          );
        }}
      </Modal>
    )}
  </ConfirmLeave>
);

ConfirmLeaveUnfinishedAssignment.propTypes = {
  route: PropTypes.object,
  onDismiss: PropTypes.func
};

export default ConfirmLeaveUnfinishedAssignment;
